<template>
  <div class="node" :style="{ marginLeft: depth * 1 + 'rem' }">
    <div class="container">
      <!-- code here -->
      <div
        class="menu-item w-full"
        :class="{
          'container--country': type == 'country',
          'container--state': type == 'state',
          'container--district': type == 'district',
          'container--city': type == 'city',
        }"
        @click="expanded = !expanded"
      >
        <span class="menu-button menu-button--black">
          <span
            :class="{
              type: true,
              'mr-3': true,
            }"
            v-if="hasChildren"
            ><img v-if="expanded" src="@/assets/images/icons/plus-box.svg" />
            <img v-else src="@/assets/images/icons/plus-box-bg.svg" /></span
          >{{ node.name }}</span
        >
        <div class="menu-sub-list" v-if="node.id != ''">
          <span class="menu-item" v-if="type == 'country'">
            <button class="menu-button menu-button--orange" @click="addIn()">
              <feather-icon
                icon="PlusCircleIcon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="add_icon"
              />
              {{$t("setup.label.AddState")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'state'">
            <button class="menu-button menu-button--orange" @click="addIn()">
              <feather-icon
                icon="PlusCircleIcon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="add_icon"
              />
              {{$t("setup.label.AddDistrict")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'district'">
            <button class="menu-button menu-button--orange" @click="addIn()">
              <feather-icon
                icon="PlusCircleIcon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="add_icon"
              />
              {{$t("setup.label.AddCity")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'country'">
            <button class="menu-button menu-button--orange" @click="edit()">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                class="edit_icon"
              />
              {{$t("setup.label.EditCountry")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'state'">
            <button class="menu-button menu-button--orange" @click="edit()">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                class="edit_icon"
              />
              {{$t("setup.label.EditState")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'district'">
            <button class="menu-button menu-button--orange" @click="edit()">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5  stroke-current cursor orange_icon"
                class="edit_icon"
              />
              {{$t("setup.label.EditDistrict")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'city'">
            <button class="menu-button menu-button--orange" @click="edit()">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                class="edit_icon"
              />
              {{$t("setup.label.EditCity")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'country'">
            <button
              class="menu-button menu-button--orange"
              @click="deleteItem()"
            >
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="delete_icon"
              />
              {{$t("setup.label.DeleteCountry")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'state'">
            <button
              class="menu-button menu-button--orange"
              @click="deleteItem()"
            >
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="delete_icon"
              />
              {{$t("setup.label.DeleteState")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'district'">
            <button
              class="menu-button menu-button--orange"
              @click="deleteItem()"
            >
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="delete_icon"
              />
              {{$t("setup.label.DeleteDistrict")}}
            </button>
          </span>
          <span class="menu-item" v-if="type == 'city'">
            <button
              class="menu-button menu-button--orange"
              @click="deleteItem()"
            >
              <feather-icon
                icon="Trash2Icon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="delete_icon"
              />
              {{$t("setup.label.DeleteCity")}}
            </button>
          </span>
          <span class="menu-item">
            <button
              v-if="node.id != ''"
              class="menu-button menu-button--orange"
              @click="serviceAvailable()"
            >
              <feather-icon
                icon="SunriseIcon"
                svgClasses="w-5 h-5  stroke-current cursor"
                class="service_icon"
              />
              {{$t("setup.label.ServiceAvailablity")}}
            </button>
          </span>
        </div>
      </div>
    </div>

    <TreeItem
      v-if="expanded"
      v-for="child in node.children"
      :key="child.name"
      :node="child"
      :depth="depth + 1"
    />
  </div>
</template>
<script>
export default {
  name: "TreeItem",
  props: {
    node: Object,
    depth: {
      type: Number,
      default: 0,
    },
    emits: ["add-state"],
  },
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
    },
    hi() {
      alert("Hi");
    },
    getPath(val) {
      if (val) {
        return "@/assets/images/icons/plus-box.svg";
      } else {
        return "@/assets/images/icons/plus-box-bg.svg";
      }
    },
    addIn() {
      if (this.node.type == "country")
        this.$parent.$emit(
          "add-in",
          this.node.id,
          this.node.type,
          this.node.code
        );
      if (this.node.type == "state")
        this.$parent.$parent.$emit(
          "add-in",
          this.node.id,
          this.node.type,
          this.node.code
        );
      if (this.node.type == "district")
        this.$parent.$parent.$parent.$emit(
          "add-in",
          this.node.id,
          this.node.type,
          this.node.code
        );
    },
    edit() {
      if (this.node.type == "country")
        this.$parent.$emit(
          "edit-item",
          this.node.id,
          this.node.type,
          this.node.code,
          this.node.name
        );
      if (this.node.type == "state")
        this.$parent.$parent.$emit(
          "edit-item",
          this.node.id,
          this.node.type,
          this.node.code,
          this.node.name
        );
      if (this.node.type == "district")
        this.$parent.$parent.$parent.$emit(
          "edit-item",
          this.node.id,
          this.node.type,
          this.node.code,
          this.node.name
        );
      if (this.node.type == "city")
        this.$parent.$parent.$parent.$parent.$emit(
          "edit-item",
          this.node.id,
          this.node.type,
          this.node.code,
          this.node.name
        );
    },

    deleteItem() {
      if (this.node.type == "country")
        this.$parent.$emit(
          "delete-item",
          this.node.id,
          this.node.type,
          this.node.code
        );
      if (this.node.type == "state")
        this.$parent.$parent.$emit(
          "delete-item",
          this.node.id,
          this.node.type,
          this.node.code
        );
      if (this.node.type == "district")
        this.$parent.$parent.$parent.$emit(
          "delete-item",
          this.node.id,
          this.node.type,
          this.node.code
        );
      if (this.node.type == "city")
        this.$parent.$parent.$parent.$parent.$emit(
          "delete-item",
          this.node.id,
          this.node.type,
          this.node.code
        );
    },
    serviceAvailable() {
      if (this.node.type == "country")
        this.$parent.$emit(
          "service-available",
          this.node.id,
          this.node.type,
          this.node.code
        );
      if (this.node.type == "state")
        this.$parent.$parent.$emit(
          "service-available",
          this.node.id,
          this.node.type,
          this.node.code
        );
      if (this.node.type == "district")
        this.$parent.$parent.$parent.$emit(
          "service-available",
          this.node.id,
          this.node.type,
          this.node.code
        );
      if (this.node.type == "city")
        this.$parent.$parent.$parent.$parent.$emit(
          "service-available",
          this.node.id,
          this.node.type,
          this.node.code
        );
    },
  },
  computed: {
    hasChildren() {
      return this.node.children;
    },
    type() {
      return this.node.type;
    },
    id() {
      return this.node.id;
    },
  },
};
</script>
<style lang="scss" scoped>
.add_icon {
  color: rgba(var(--vs-success), 1);
}
.edit_icon {
  color: rgba(var(--vs-warning), 1);
}
.delete_icon {
  color: rgba(var(--vs-danger), 1);
}
.service_icon {
  color: rgba(var(--vs-primary), 1);
}
.node {
  text-align: left;
}
.menu-sub-list {
  display: none;
  padding: 5px;
  background-color: #fbfbfb;
  border-radius: 5px;
  box-shadow: 0 10px 20px rgba(#404040, 0.15);
  position: absolute;
  left: 100%;
  right: 0;
  z-index: 1000;
  width: 15.5rem;
  top: 0;
  flex-direction: column;
  &:hover {
    display: flex;
  }
}

.menu-item {
  position: relative;
}

.menu-button {
  font: inherit;
  border: 0;
  padding: 8px 8px;
  padding-right: 0;
  width: 100%;

  text-align: left;
  display: flex;
  align-items: center;
  position: relative;
  background-color: var(--color-bg-secondary);
  border: solid rgba(0, 0, 0, 0.2);
  &:hover {
    .add_icon,
    .edit_icon,
    .delete_icon,
    .service_icon {
      color: #fff;
    }
    background: rgba(var(--vs-primary), 0.2);
    & + .menu-sub-list {
      display: flex;
    }
    svg {
      stroke: var(--color-text-primary);
    }
  }
  svg {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    stroke: var(--color-text-primary-offset);
    &:nth-of-type(2) {
      margin-right: 0;
      position: absolute;
      right: 8px;
    }
  }

  &--delete {
    &:hover {
      color: var(--color-red);
      svg:first-of-type {
        stroke: var(--color-red);
      }
    }
  }

  &--orange {
    svg:first-of-type {
      stroke: var(--color-orange);
    }
  }

  &--green {
    svg:first-of-type {
      stroke: var(--color-green);
    }
  }
  &--purple {
    svg:first-of-type {
      stroke: var(--color-purple);
    }
  }
  &--black {
    svg:first-of-type {
      stroke: var(--color-black);
    }
  }

  &--checked {
    svg:nth-of-type(2) {
      stroke: var(--color-purple);
    }
  }
}

// Codepen spesific styling - only to center the elements in the pen preview and viewport
.container {
  display: flex;
  align-items: left;
  justify-content: left;
  transition: all 0.5s;
  margin: 5px;
  cursor: pointer;
  padding-right: 0;
  margin-right: 0;
  &--country {
    max-width: 28rem;
    background: darken($color: #fff, $amount: 1);
    margin-right: 0;
  }
  &--state {
    max-width: 26rem;
    margin-right: 0;
    background: darken($color: #fff, $amount: 4);
  }
  &--district {
    max-width: 23rem;
    margin-right: 0;
    background: darken($color: #fff, $amount: 7);
  }
  &--city {
    max-width: 19rem;
    margin-right: 0;
    background: darken($color: #fff, $amount: 10);
  }
  &:hover {
    transform: translateX(0.5rem);
  }
}
</style>
